import { Box, Flex, Icon, Text, Tooltip, VStack } from '@chakra-ui/react';
import { InternalGetIngestionDocumentFragment } from '@client/graphql/__generated__/types';
import { startCase } from 'lodash';
import { InfoIcon } from 'lucide-react';
import { FC, useMemo } from 'react';

interface ComplianceGroupInfoProps {
  document: InternalGetIngestionDocumentFragment;
}

export const ComplianceGroupInfo: FC<ComplianceGroupInfoProps> = ({
  document,
}) => {
  const { complianceGroupId, complianceGroupMetadata } = document;

  const metadataContent = useMemo(() => {
    if (!complianceGroupId || !complianceGroupId.trim()) {
      return (
        <Text color="compliance.text.muted" fontSize="sm">
          No workflow assigned to this document
        </Text>
      );
    }

    return (
      <>
        <VStack align="stretch" spacing={1}>
          <Flex justify="space-between">
            <Text color="compliance.text.muted" fontSize="sm">
              ID:
            </Text>
            <Text fontSize="sm">{complianceGroupId}</Text>
          </Flex>
          {/* Show name from resolver field (includes Dotloop API data) */}
          {complianceGroupMetadata?.name && (
            <Flex justify="space-between">
              <Text color="compliance.text.muted" fontSize="sm">
                Name:
              </Text>
              <Text fontSize="sm" fontWeight="medium">
                {complianceGroupMetadata.name}
              </Text>
            </Flex>
          )}

          {/* Show stage from resolver field (includes stage mapping) */}
          {complianceGroupMetadata?.transactionStageType && (
            <Flex justify="space-between">
              <Flex alignItems="center" gap={1}>
                <Text color="compliance.text.muted" fontSize="sm">
                  Mapped Stage:
                </Text>
                <Tooltip label="This is the mapped stage in Indigo's Admin settings">
                  <Icon as={InfoIcon} color="compliance.text.muted" />
                </Tooltip>
              </Flex>
              <Text fontSize="sm" fontWeight="medium">
                {startCase(
                  complianceGroupMetadata.transactionStageType.toLowerCase()
                )}
              </Text>
            </Flex>
          )}
        </VStack>
      </>
    );
  }, [complianceGroupMetadata, complianceGroupId]);

  return (
    <Box
      bg="compliance.card.bg"
      border="1px"
      borderColor="compliance.card.border"
      borderRadius="md"
      p={3}
    >
      <VStack align="stretch" spacing={2}>
        <Text color="compliance.card.title" fontSize="sm" fontWeight="medium">
          Workflow (Compliance Group)
        </Text>
        {metadataContent}
      </VStack>
    </Box>
  );
};
